// JUST TO HANDLE REDUX LOGIC, DISPATCHES ACTIONS, ACCESSES GLOBAL STATE
// IMPORTANT	--DO NOT DO CALLS TO (API)-- PLEASE USE SERVICE FILE

import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getAllAvailabilityEvents,
  getAvailabilityEvent,
  createAvailabilityEvent,
  updateAvailabilityEvent,
  deleteAvailabilityEvent,
} from './availabilityService';

// Fetch all availability events for a user
export const fetchAvailabilityEvents = createAsyncThunk('availability/fetchAvailabilityEvents', async (userId) => {
  const events = await getAllAvailabilityEvents(userId);
  return events;
});

// Fetch a single availability event
export const fetchAvailabilityEvent = createAsyncThunk(
  'availability/fetchAvailabilityEvent',
  async ({ userId, eventId }) => {
    const event = await getAvailabilityEvent(userId, eventId);
    return event;
  }
);

// Create a new availability event
export const createAvailabilityEventThunk = createAsyncThunk(
  'availability/createAvailabilityEvent',
  async ({ eventData }) => {
    const event = await createAvailabilityEvent(eventData);
    return event;
  }
);

// Update an availability event
export const updateAvailabilityEventThunk = createAsyncThunk(
  'availability/updateAvailabilityEvent',
  async ({ eventId, eventData }) => {
    const event = await updateAvailabilityEvent(eventId, eventData);
    return event;
  }
);

// Delete an availability event
export const deleteAvailabilityEventThunk = createAsyncThunk(
  'availability/deleteAvailabilityEvent',
  async ({ userId, eventId }) => {
    await deleteAvailabilityEvent(userId, eventId);
    return eventId;
  }
);
